// extracted by mini-css-extract-plugin
module.exports = {"arrows":"T_dD","arrows__right":"T_dF","arrows__left":"T_dG"};